"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const isEqual_1 = tslib_1.__importDefault(require("lodash/isEqual"));
const merge_1 = tslib_1.__importDefault(require("lodash/merge"));
const react_1 = tslib_1.__importDefault(require("react"));
/** 使用React包装的Valine评论组件 */
class Valine extends react_1.default.PureComponent {
    constructor(props) {
        super(props);
        this._containerRef = react_1.default.createRef();
    }
    async componentDidMount() {
        if (this._checkAvailability()) {
            await this._makeValine();
        }
    }
    async componentDidUpdate(prevProps) {
        if (isEqual_1.default(this.props, prevProps)) {
            return;
        }
        if (this._checkAvailability()) {
            await this._makeValine();
        }
    }
    render() {
        return react_1.default.createElement("div", Object.assign({ ref: this._containerRef }, this.props));
    }
    _checkAvailability() {
        return typeof window !== 'undefined' && !!this._containerRef.current;
    }
    async _makeValine() {
        const RealValine = await (await Promise.resolve().then(() => tslib_1.__importStar(require('valine')))).default;
        const localOptions = this.props;
        const globalOptions = window.valineOptions;
        const options = merge_1.default({}, globalOptions, localOptions);
        delete options.el;
        new RealValine({
            ...options,
            el: this._containerRef.current,
        });
        window.valineOptions;
    }
}
exports.default = Valine;
